import { AdSource } from '@/generated'

/**
 * Checks if listing is a CAS listing based on the AdSource
 */
export const isCasListing = (adSource: string): boolean => {
  return adSource === AdSource.Cas
}
